export default "__VITE_ASSET__CakfJcy3__"